const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  // Safe in production — no stack traces or sensitive detail
  error: (message) => {
    if (isDev) {
      console.error(message);
    }
  },
  // Only ever runs in development
  debug: (message, detail) => {
    if (isDev) {
      console.log('[debug]', message, detail);
    }
  }
};
